"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 *
 * @param {String} expirationMonth
 * @param {String} expirationYear
 *
 * @returns true if date is expired
 */
var isCardExpired = function isCardExpired(expirationMonth, expirationYear) {
  var todaysDate = new Date();
  var currentYear = todaysDate.getFullYear();
  var currentMonth = todaysDate.getMonth() + 1;
  var isExpired = false;
  if (Number(expirationYear) < currentYear) {
    isExpired = true;
  } else if (Number(expirationYear) === currentYear && Number(expirationMonth) < currentMonth) {
    isExpired = true;
  }
  return isExpired;
};
var _default = exports["default"] = isCardExpired;